import { SetItemProductionMappingsMutation } from "~/gql/mutations/itemProductionMapping.generated";
import {
	GetItemProductionMappingsQuery,
	GetProductionItemsCatalogQuery
} from "~/gql/queries/itemProductionMapping.generated";

const itemProductionMappingEndpoints = {
	GetItemProductionMappings: {
		providesTags: ["ItemProductionMappings"] as AddTagTypes,
		transformResponse: (res: GetItemProductionMappingsQuery) => res
	},
	GetProductionItemsCatalog: {
		providesTags: ["ProductionItems"] as AddTagTypes,
		transformResponse: (res: GetProductionItemsCatalogQuery) => res
	},
	SetItemProductionMappings: {
		invalidatesTags: ["ItemProductionMappings"] as AddTagTypes,
		transformResponse: (res: SetItemProductionMappingsMutation) => res
	}
};

export default itemProductionMappingEndpoints;
